const createPowerReviewsConfig = ({
  config,
  locale,
  productId,
  variantId,
  type,
  id,
  returnUrl,
  onRender,
  onSubmit
}) => ({
  enable_content_collection_modal: false,
  api_key: config.apiKey,
  locale: locale.replace("-", "_"),
  merchant_group_id: config.groupId,
  merchant_id: config.opcoId,
  // Append the "?" as PowerReviews doesn't do that but will add query params.
  review_wrapper_url: `${config.writeReviewPath}?`,
  components: {
    [type]: id
  },
  ...productId && { page_id: productId },
  ...variantId && { page_id_variant: variantId },
  ...returnUrl && { return_url: returnUrl },
  ...onRender && { on_render: onRender },
  ...onSubmit && { on_submit: onSubmit }
});
const mergeConfigs = (configs) => {
  return configs.reduce(
    (result, next) => ({
      ...result,
      ...next,
      components: {
        ...result.components,
        ...next.components
      }
    }),
    {}
  );
};
export {
  createPowerReviewsConfig,
  mergeConfigs
};
//# sourceMappingURL=create-powerreviews-config.js.map
